<template>
  <div class="page-header">
    <div class="header-title">
      <i v-if="icon" :class="icon"></i>
      <span>{{ title }}</span>
    </div>
    <div class="header-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.page-header {
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.header-title i {
  margin-right: 8px;
  font-size: 20px;
}

.header-content {
  margin-top: 10px;
}
</style> 